export default "__VITE_ASSET__c15ba758__"